// Service Worker Update Handler
// Automatically refreshes the page when a new service worker version is detected

export function initServiceWorkerUpdateHandler() {
  // Listen for messages from the service worker
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'CACHE_UPDATED') {
        console.log('[ServiceWorker] New version detected:', event.data.version);

        // Show a brief notification to the user
        const notification = document.createElement('div');
        notification.style.cssText = `
          position: fixed;
          top: 20px;
          right: 20px;
          background: #10b981;
          color: white;
          padding: 16px 24px;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 500;
          z-index: 999999;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          animation: slideIn 0.3s ease-out;
        `;
        notification.textContent = 'Updating to latest version...';
        document.body.appendChild(notification);

        // Add animation
        const style = document.createElement('style');
        style.textContent = `
          @keyframes slideIn {
            from { transform: translateX(100%); opacity: 0; }
            to { transform: translateX(0); opacity: 1; }
          }
        `;
        document.head.appendChild(style);

        // Reload after a short delay to let user see the message
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      }
    });

    // Check for updates periodically (every 5 minutes)
    setInterval(() => {
      if (navigator.serviceWorker.controller) {
        navigator.serviceWorker.ready.then(registration => {
          registration.update().catch(err => {
            console.error('[ServiceWorker] Update check failed:', err);
          });
        });
      }
    }, 5 * 60 * 1000); // 5 minutes

    // Check for updates when the page gains focus
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden && navigator.serviceWorker.controller) {
        navigator.serviceWorker.ready.then(registration => {
          registration.update().catch(err => {
            console.error('[ServiceWorker] Update check failed:', err);
          });
        });
      }
    });
  }
}

// Also check if there's a waiting service worker on page load
export function checkForWaitingServiceWorker() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(registration => {
      if (registration.waiting) {
        // There's a waiting service worker, prompt for update
        console.log('[ServiceWorker] New version waiting, activating...');
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }

      // Listen for any future updates
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New service worker installed, reload the page
              console.log('[ServiceWorker] New version installed, reloading...');
              window.location.reload();
            }
          });
        }
      });
    });
  }
}